import { createFileRoute } from '@tanstack/react-router';
import { IFellowshipKindEnum } from 'src/graphql/types';
import Fellowships from 'src/pages/Organization/Fellowships';

export const Route = createFileRoute('/$organizationSlug/mechanics/faiths/$')({
  component: () => (
    <Fellowships
      allowMembershipsEdit={false}
      type={IFellowshipKindEnum.Faith}
    />
  ),
});
